import {SET_DATE_MODAL} from "../../types";

export function setParamsSetDateModal(data) {
    return (dispatch) => {
        dispatch({type: SET_DATE_MODAL, payload: data});
    }
}
